//대시보드
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import { Body2, Sub2, H4 } from "../../../assets/styles/Typography";
import { Button } from "../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import { useAtom } from "jotai";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DISPLAY_LIST,
  AUTODISPLAY_CONTENT_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  CUSTOMER_DETAIL,
} from "../../AtomStates";

import MoleculeContentTypeSelectPopup from "../components/molecules/MoleculeContentTypeSelectPopup";
import OrganismEduInfoContentList from "../components/organisms/OrganismEduInfoContentList";
import {
  getDeviceListOnServer,
  getUserMemberType,
  getEduBoardDetailOnServer,
  getCustomerDetailOnServer,
  getInfoBoardContentsListOnServer,
} from "../../../utils/indexedDB";

const PageEduInfoContentManageDashBoard = () => {
  const navigate = useNavigate();

  // 대시보드 상태 데이터
  const [stats] = useState({
    displayList: 5,
    totalContent: 20,
    activeContent: 10,
    credits: 21250,
  });
  const [activeTab, setActiveTab] = useState("content");
  // 뷰 전환 상태 추가
  const [currentView, setCurrentView] = useState("dashboard"); // 'dashboard' | 'contentsList'
  // 팝업 관련 상태
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice, setSelectedDevice] = useAtom(
    AUTODISPLAY_SELECTED_DEVICE
  );
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [isCustomizePopupOpen, setIsCustomizePopupOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [addDisplayForm, setAddDisplayForm] = useState({
    deviceTitle: "",
    deviceLocation: "",
    deviceTarget: "",
    deviceSpec: {
      deviceWidth: "",
      deviceHeight: "",
      deviceWidthMM: "",
      deviceHeightMM: "",
      deviceCm: "",
      deviceResolution: "",
      deviceDPI: "",
      deviceInch: "",
    },
  });
  const [activateCount, setActivateCount] = useState(0);
  const [selectBoxStates, setSelectBoxStates] = useState({
    deviceDPI: false,
    deviceInch: false,
  });
  const [showDeviceSelectPopup, setShowDeviceSelectPopup] = useState(false);
  const [isTypingDPI, setIsTypingDPI] = useState(false);
  const [isTypingInch, setIsTypingInch] = useState(false);
  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [newDisplayId, setNewDisplayId] = useState(null);
  const [selectedEditDisplayId, setSelectedEditDisplayId] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [monthOffset, setMonthOffset] = useState(0);
  const [timelineViewType, setTimelineViewType] = useState("weekly"); // 'weekly' | 'monthly'
  const [currentWeekOffset, setCurrentWeekOffset] = useState(0); // 현재 주로부터의 오프셋
  const [currentUserName, setCurrentUserName] = useState("");
  const [eduTimetableDetail, setEduTimetableDetail] = useState(null);
  const [isTimetableLoading, setIsTimetableLoading] = useState(true);
  const [lotationDetail, setLotationDetail] = useState(null);
  const [contentListAllCount, setContentListAllCount] = useState(0);
  const [showContentTypePopup, setShowContentTypePopup] = useState(false);


  const fetchCustomerDetail = async (userMemberType) => {
    const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
    setCustomerId(customerIdFromStorage);
    if (customerIdFromStorage !== "") {
      try {
        let customerDetailResponse;
        if (
          userMemberType.member_type === 31 ||
          userMemberType.member_type === 32
        ) {
          customerDetailResponse = await getEduBoardDetailOnServer(
            customerIdFromStorage,
            isLoggedIn
          );
        } else {
          customerDetailResponse = await getCustomerDetailOnServer(
            customerIdFromStorage,
            isLoggedIn
          );
        }
        if (customerDetailResponse) {
          setCustomerDetail(customerDetailResponse);
          setCompanyName(customerDetailResponse.companyName);
          // console.log("customerDetailResponse", customerDetailResponse);
        }
      } catch (error) {
        console.error("고객사 정보를 불러오는 중 오류가 발생했습니다:", error);
      }
    }
  };

  const getLotationList = async () => {
    try {
      const userName = sessionStorage.getItem("userName");
      setCurrentUserName(userName);
      const customerId = sessionStorage.getItem("customerId");
      // 편성 데이터 로드
      const lotationDetailData = await getInfoBoardContentsListOnServer(
        customerId,
        isLoggedIn
      );
      // console.log("lotationDetailData: ", lotationDetailData)
      setLotationDetail(lotationDetailData);
      // console.log("lotationDetailData: ", lotationDetailData);
    } catch (error) {
      console.error("Error fetching lotation list:", error);
    } finally {
      setIsTimetableLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        await checkMemberType();
        await getLotationList();
        await fetchContentList();
        await fetchCustomerDetail(
          await getUserMemberType(sessionStorage.getItem("accessToken"))
        );
      } catch (error) {
        console.error("Error initializing:", error);
      } finally {
        setIsTimetableLoading(false);
      }
    };
    init();
  }, []);

  const checkMemberType = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    const userMemberType = await getUserMemberType(accessToken);

    const lastUrl = sessionStorage.getItem("lastUrl");

    const currentUrl = window.location.href;
    sessionStorage.setItem("lastUrl", currentUrl);

    // fetchCustomerAndTimetableDetails(0); // Initial fetch

    // URL 파라미터 확인하여 콘텐츠 리스트 뷰로 이동
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("view") === "contentsList") {
      setCurrentView("contentsList");
    }

    if (
      (lastUrl === "/ApiDashBoard" || lastUrl === "/CreateApiContent") &&
      userMemberType.member_type === 99
    ) {
      navigate("/Admin");
    }

    if (userMemberType.member_type === 11) {
      navigate("/DashBoard");
    } else if (userMemberType.member_type === 12) {
      navigate("/CustomerManage");
    } else if (userMemberType.member_type === 21) {
      navigate("/ApiDashBoard");
    } else if (userMemberType.member_type === 22) {
      navigate("/CustomerManage");
    }
  };

  // 데이터 fetching 함수 분리
  const fetchContentList = async () => {
    if (!isLoggedIn) {
      return; // 로그인 상태가 아니면 API를 호출하지 않음
    }

    try {
      let response;
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 ||
          memberType.member_type === 21 ||
          memberType.member_type === 31)
      ) {
        response = await getDeviceListOnServer(10, 1, isLoggedIn);
        setDisplayList(response.data);
      } else {
        response = await getDeviceListOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        setDisplayList(response.data);
      }

      let viewList;

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 ||
          memberType.member_type === 21 ||
          memberType.member_type === 31)
      ) {
        viewList = await getInfoBoardContentsListOnServer("", isLoggedIn);
        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      } else {
        viewList = await getInfoBoardContentsListOnServer(
          customerIdFromStorage,
          isLoggedIn
        );

        console.log("viewList: ", viewList);

        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      }

      setContentList(viewList.data);

      setContentListAllCount(
        viewList?.data?.length || viewList?.count);
      
    } catch (error) {
      console.error("콘텐츠 리스트를 불러오는 중 오류가 발생했습니다:", error);
    }
  };

  const handleInfoDashboardClick = () => {
    navigate("/EduInfoDashBoard");
  };


  // 새 콘텐츠 버튼 클릭 시 뷰 전환
  const handleNewContentClick = () => {
    setShowContentTypePopup(true);
  };

  

  // 사이즈 계산 로직
  useEffect(() => {
    const { deviceDPI, deviceInch } = addDisplayForm.deviceSpec;

    if (!deviceDPI || !deviceInch) return;

    try {
      const resolutionMatch = deviceDPI.match(/(\d{3,})\s*[×x*]\s*(\d{3,})/);
      const inchMatch = deviceInch.match(/(\d+(\.\d+)?)/);

      if (!resolutionMatch || !inchMatch) return;

      const widthPx = parseInt(resolutionMatch[1], 10);
      const heightPx = parseInt(resolutionMatch[2], 10);
      const diagonalInch = parseFloat(inchMatch[1]);

      const aspectRatio = widthPx / heightPx;
      const heightInch = diagonalInch / Math.sqrt(aspectRatio ** 2 + 1);
      const widthInch = heightInch * aspectRatio;

      const widthMm = Math.round(widthInch * 25.4);
      const heightMm = Math.round(heightInch * 25.4);

      setAddDisplayForm((prev) => ({
        ...prev,
        deviceSpec: {
          ...prev.deviceSpec,
          deviceWidth: widthPx.toString(),
          deviceHeight: heightPx.toString(),
          deviceWidthMM: widthMm.toString(),
          deviceHeightMM: heightMm.toString(),
        },
      }));
    } catch (e) {
      console.error("Failed to calculate display size", e);
    }
  }, [
    addDisplayForm.deviceSpec.deviceDPI,
    addDisplayForm.deviceSpec.deviceInch,
  ]);



 
  // 일반 콘텐츠 생성 핸들러
  const handleCreateGeneralContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEduInfoContent", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 급식 콘텐츠 생성 핸들러
  const handleCreateMealContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEduInfoContentMeal", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 링크 콘텐츠 생성 핸들러
  const handleCreateLinkContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEduInfoContentLink", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 커스텀 콘텐츠 생성 핸들러
  const handleCreateCustomContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEduInfoCustomContent", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 콘텐츠 유형 선택 팝업 닫기
  const handleContentTypePopupClose = () => {
    setShowContentTypePopup(false);
  };

  // 일반 콘텐츠 선택
  const handleSelectGeneralContent = () => {
    setShowContentTypePopup(false);
    handleCreateGeneralContent();
  };

  // 급식 콘텐츠 선택
  const handleSelectMealContent = () => {
    setShowContentTypePopup(false);
    handleCreateMealContent();
  };

  // 링크 콘텐츠 선택
  const handleSelectLinkContent = () => {
    setShowContentTypePopup(false);
    handleCreateLinkContent();
  };

  // 커스텀 콘텐츠 선택
  const handleSelectCustomContent = () => {
    setShowContentTypePopup(false);
    handleCreateCustomContent();
  };

  return (
    <>
    <DashboardContainer>
      <MoleculeHeader />
      <MainContent>
        <StatsSection>
          <TopSection>
            <SectionTitle> {companyName} 콘텐츠 통합 관리</SectionTitle>
            <ButtonGroup>
              <Button
                Large
                primaryLightest
                Fill
                onClick={handleInfoDashboardClick}
              >
              <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <circle cx="10" cy="10" r="1.5" fill="#256EF4" />
              <path
                d="m10 1 3 3-3 3-3-3 3-3zM10 19l3-3-3-3-3 3 3 3zM16 7l3 3-3 3-3-3 3-3zM4 13l3-3-3-3-3 3 3 3z"
                fill="#256EF4"
              />
            </svg>
                <Sub2 color="primary">기기 관리</Sub2>
              </Button>
              <Button
                Large
                Primary
                Fill
                onClick={() => handleNewContentClick()}
                style={{ display: "inline-flex", alignItems: "center" }}
              >
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M9.99935 4.16669V15.8334M4.16602 10H15.8327"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <Sub2 color="white">콘텐츠 생성하기</Sub2>
              </Button>
            </ButtonGroup>
          </TopSection>
          <StatsGrid>
            <StatCard>
              <StatTitle>
                <H4 color="gray800">콘텐츠 현황 </H4>
             
              </StatTitle>
              <StartContent>
                <StatGroup>
                  <StatValue>
                    {isTimetableLoading ||
                    !lotationDetail ||
                    !contentListAllCount ? (
                      "- / -"
                    ) : (
                      <>
                        <ActivatedCount>
                          {contentList.filter(item => item.isScheduled === 1).length}
                        </ActivatedCount>
                        {` / ${contentListAllCount || 0}`}
                      </>
                    )}
                  </StatValue>
                  <StatHeader>
                    <Body2 color="gray600"> 활성 / 전체</Body2>
                    {/* <Body2 color="gray600">개수</Body2> */}
                  </StatHeader>
                </StatGroup>
              </StartContent>
            </StatCard>
          </StatsGrid>
        </StatsSection>

        <TimelineSection>
          {/* <StatHeader2>
            
            <H4 color="primary">{customerName} </H4>
            <H4 color="gray700">콘텐츠 편성 관리 </H4>
          </StatHeader2> */}
          {isTimetableLoading ? (
            <LoadingSpinner>
              <Spinner />
            </LoadingSpinner>
          ) : (
            <>
              <OrganismEduInfoContentList
                contentList={contentList}
                lotationDetail={lotationDetail}
                showLinkBar={false}
                onLotationUpdate={async () => {
                  // 편성 데이터가 업데이트되면 다시 로드
                  try {
                    const updatedLotationDetail =
                      await getInfoBoardContentsListOnServer(
                        customerId,
                        isLoggedIn
                      );
                    setLotationDetail(updatedLotationDetail);
                    // console.log(
                    //   "Lotation Detail refreshed:",
                    //   updatedLotationDetail
                    // );
                  } catch (error) {
                    console.error("Error refreshing lotation detail:", error);
                  }
                }}
                onContentListUpdate={async () => {
                  await fetchContentList();
                }}
              />
            
            </>
          )}
        </TimelineSection>
       
      </MainContent>

      
    </DashboardContainer>
    {showContentTypePopup && (
      <MoleculeContentTypeSelectPopup
        onClose={handleContentTypePopupClose}
        onSelectGeneral={handleSelectGeneralContent}
        onSelectMeal={handleSelectMealContent}
        onSelectLink={handleSelectLinkContent}
        onSelectCustom={handleSelectCustomContent}
        excludeContent = {true}
      />
    )}
    </>
  );
};

export default PageEduInfoContentManageDashBoard;

// PopupContent 스타일 추가
const PopupContent = styled.div`
  margin-top: 8px;
`;

// 스타일 컴포넌트들
const DashboardContainer = styled.div`
  width: 100%;
  max-width: 2330px;
  margin: 0 auto;
  background: ${palette.white};
  min-height: 100vh;
`;

const MainContent = styled.main`
  max-width: 1240px;
  margin: 0 auto;
  padding: 145px 0;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  background: #d9d9d9;
  border-radius: 50%;
  background-image: url("/logo192.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const CompanyName = styled.h2`
  font-family: poppins;
  font-weight: 700;
  font-size: 40px;
  color: #1e2124;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
`;

const StatsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const SectionTitle = styled.h3`
  font-family: Pretendard;
  font-weight: 600;

  font-size: 32px;
  color: #323232;
  margin: 0;
  text-align: left;
`;

const StatsGrid = styled.div`
  display: flex;
  gap: 20px;
`;

const StatCard = styled.div`
  // flex: 1;
  flex: 0 0 calc(33.333% - 13.333px);
  background: ${palette.white};
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  padding: 24px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;
`;

const StatTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e4eb;
  text-align: left;
  align-items: flex-end;
`;

const StartContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 150px;
`;

const StatGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StatHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // margin-left: -20px;
`;

const StatHeader2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const StatValue = styled.div`
  font-family: Poppins;
  font-weight: 700;
  font-size: 30px;
  color: #666666;
  text-align: left;
`;

const TimelineSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const Tab = styled.button`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? "#E0E4EB" : "#e0e4eb")};
  background: ${({ active }) => (active ? "#F7F8FA" : "transparent")};
  color: ${palette.gray700};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  font-size: 15px;
  cursor: pointer;
  margin-right: 8px;
  transition: background 0.2s, color 0.2s, border 0.2s;

  &:last-child {
    margin-right: 0;
  }
`;

const Table = styled.div`
  border-radius: 0;
  overflow: hidden;
`;

const TableHeader = styled.div`
  display: flex;
  background: #eef2f7;
`;

const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableRow = styled.div`
  display: flex;
  background: ${palette.white};

  &:not(:last-child) {
    border-bottom: 1px solid #cdd1d5;
  }
`;

const HeaderCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  color: #131416;
  border-right: 1px solid #d6e0eb;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const TableCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 17px;
  color: #464c53;
  border-right: 1px solid #cdd1d5;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const PopupFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0;
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 4px;
  flex: ${(props) => props.flex || "none"};
  margin-bottom: -10px;

  Body2 {
    margin-bottom: 10px;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SizeInput = styled.input`
  flex: 1;
  padding: 16px;
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  font-size: 1rem;
  color: ${palette.gray700};

  &:focus {
    outline: none;
    border-color: ${palette.primary};
  }

  &::placeholder {
    color: ${palette.gray500};
  }
`;

const SizeUnit = styled.span`
  font-size: 14px;
  color: ${palette.gray600};
  min-width: 24px;
`;

const ButtonCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const InfoBox = styled.div`
  background-color: ${palette.primaryLightest};
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 16px;
`;

const LargeButton = styled(Button)`
  width: 200px;
  padding: 16px 32px;
  font-size: 16px;
  min-height: 56px;
`;

const DirectInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${palette.gray400};
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${palette.gray100};
    color: ${palette.gray700};
  }
`;

const ContentLink = styled.a`
  color: ${palette.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${palette.primary}DD;
    text-decoration: underline;
  }

  &:visited {
    color: ${palette.primary};
  }
`;

const CustomPopupSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${palette.gray600};
  margin: 0;
  margin-bottom: 12px;
`;

const StatCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DisplayInfoContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const DisplayInfoText = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 24px;
  color: #666666;
  font-weight: 700;
  text-align: left;
  line-height: 1.8;
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px; // 타임라인의 대략적인 높이
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const ActivatedCount = styled.span`
  color: ${palette.primary};
`;
